module.exports = __webpack_public_path__ + "static/img/10.f78e128.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/10.png
// module id = KpTR
// module chunks = 0